import {
  IDeletedConfigurationListItem,
  IDeletedConfigurationPageRequestParams,
} from "api/entities/deleted-config";
import { IPage } from "api/entities/page";
import { deletedConfigService } from "api/services/deleted-config-service";
import React, { useEffect, useState } from "react";
import { getEmptyPage, getDefaultRequestParams } from "redux/reducers/entity";
import { useApi } from "utils/hooks/use-api";
import styles from "./archive.styles.module.scss";
import RefreshButton from "components/shared-ui/button/refresh-button";
import PageTitle from "components/shared-ui/pageTitle";
import { ArchiveTable } from "./archive-table/archive-table";

export default function Archive() {
  const [deletedConfigApi, isDeletedConfigLoading] = useApi();
  const [deletedConfigPage, setDeletedConfigPage] =
    useState<IPage<IDeletedConfigurationListItem>>(getEmptyPage());
  const [requestParams, setRequestParams] =
    useState<IDeletedConfigurationPageRequestParams>({
      ...getDefaultRequestParams(),
    });

  const requestData = (
    params: Partial<IDeletedConfigurationPageRequestParams>,
  ) => {
    const updatedParams = { ...requestParams, ...params };
    setRequestParams(updatedParams);
    return deletedConfigApi(
      deletedConfigService.getPage(updatedParams).then((page) => {
        setDeletedConfigPage(page);
        return page;
      }),
    );
  };

  useEffect(() => {
    requestData(requestParams)
  }, []);

  return (
    <>
      <div className={styles.header}>
        <PageTitle title={`Archived Configurations`}>
          <RefreshButton onClick={() => requestData(requestParams)} />
        </PageTitle>
      </div>

      <ArchiveTable
        setRequestParams={requestData}
        isLoading={isDeletedConfigLoading}
        page={deletedConfigPage}
        requestParams={requestParams}
        isRowClickable={false}
        hasManageColumn
      />
    </>
  );
}
